import { Text } from "@/elements"
import { FragmentType, graphql, useFragment } from "@/gql"
import { MiniJobCardFragmentDoc } from "@/gql/graphql"
import { TextVariant } from "@/theme"
import clsx from "clsx"
import Image from "next/image"
import Link from "next/link"

graphql(`
  fragment MiniJobCard on JobPosting {
    id
    title
    coverImage {
      id
      thumbnailUrl200: thumbnailUrl(width: 200)
    }
  }
`)

const textSizeMap = {
  small: "body2",
  medium: "h6",
  large: "body1",
} as const

const imageSizeMap = {
  small: "size-9",
  medium: "size-9",
  large: "size-12",
} as const

const cardSizeMap = {
  small: "h-[60px]",
  medium: "h-[60px]",
  large: "h-[72px]",
} as const

interface Props {
  jobPosting: FragmentType<typeof MiniJobCardFragmentDoc> | undefined | null
  size?: "small" | "medium" | "large"
  imageSide?: "left" | "right"
  cardHeight?: "fixed" | "auto"
}
export const MiniJobCard: React.FC<Props> = ({
  size = "large",
  imageSide = "left",
  cardHeight = "fixed",
  ...props
}) => {
  const jobPosting = useFragment(MiniJobCardFragmentDoc, props.jobPosting)
  const textSize: TextVariant = textSizeMap[size]
  const imageSize = imageSizeMap[size]
  return (
    <Link
      href={`/jobs/${jobPosting?.id}`}
      className={clsx(
        "flex items-center gap-x-3 rounded-md border border-bg-3 p-3 shadow-subtle",
        cardHeight === "fixed" ? cardSizeMap[size] : "h-auto",
        imageSide === "left" ? "flex-row" : "flex-row-reverse",
        "transition-all hover:scale-[101%]"
      )}>
      {jobPosting?.coverImage?.thumbnailUrl200 ? (
        <Image
          className={clsx("aspect-square shrink-0 rounded-sm object-cover", imageSize)}
          src={jobPosting?.coverImage?.thumbnailUrl200}
          alt={"Job cover image"}
          width={200}
          height={200}
        />
      ) : null}
      <Text maxLines={2} variant={textSize} className="text-fg-1">
        {jobPosting?.title}
      </Text>
    </Link>
  )
}
